module.exports = __webpack_public_path__ + "static/img/yindu.2bec54b9.jpg";